export const CAMPAIGN_NAME_LENGTH_LIMIT = 40;
